import { getMonthName } from '@plato/ui-legacy/lib/chart-helpers';

export function mapChartData<T extends { monthInt: number }>(data: T[], year: number, locale: string) {
    return data.map((item) => ({
        ...item,
        month: getMonthName(new Date(year, item.monthInt - 1, 1), locale),
        monthLong: getMonthName(new Date(year, item.monthInt - 1, 1), locale, false),
    }));
}
